/**
 * @param {String} key
 * Takes field name as key and returns the
 * entire database jonining path from scheduler object
 * to the respective fields
 * @returns {String} the full path
 */

const fullFieldPath = (key) => {
  switch (key) {
    case 'teacher':
      return 'teacher_uuid';
    case 'course':
      return 'course_uuid';
    case 'centre':
      return 'centre_uuid';
    case 'date':
      return 'date';
    case 'date_lte':
      return 'date_lte';
    case 'date_gte':
      return 'date_gte';
    default:
      return key;
  }
};

export default fullFieldPath;
